const RiderDisciplineIndex = () => import('./views/RiderDisciplineIndex.vue')
const RiderDisciplineCreate = () => import('./views/RiderDisciplineCreate.vue')
const RiderDisciplineEdit = () => import('./views/RiderDisciplineEdit.vue')

export default [
  {
    path: 'riders/disciplines',
    name: 'riders.disciplines.index',
    component: RiderDisciplineIndex
  },
  {
    path: 'riders/disciplines/create',
    name: 'riders.disciplines.create',
    component: RiderDisciplineCreate
  },
  {
    path: 'riders/disciplines/:disciplineId(\\d+)',
    name: 'riders.disciplines.edit',
    component: RiderDisciplineEdit
  }
]
